import script from "./BaseThresholdComponent.vue?vue&type=script&lang=js"
export * from "./BaseThresholdComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__